// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2C9GX","title":"Info_title__3r6W9","links":"Info_links__3bBnH","link":"Info_link__1MqmV","logo":"Info_logo__VI5y-"};